import { parseCookies, setCookie } from 'nookies'

export const RequestMethod = {
    GET: 'GET',
    POST: 'POST'
}

const setTokenAndUid = (response, ctx) => {
    if (response.token) {
        setCookie(ctx || {}, 'customer_token', response.token, {
            maxAge: 365 * 24 * 60 * 60,
            path: '/'
        })
    }
    if (response.customerUid) {
        setCookie(ctx, 'customer_uid', response.customerUid, {
            path: '/'
        })
    }
}

const getTokenFromCookie = (ctx) => {
    const clientCookies = parseCookies(ctx)
    const token = clientCookies.customer_token ?? clientCookies.zdr_auth_token
    return token ? `Bearer ${token}` : ''
}

// eslint-disable-next-line no-shadow
const fetchResponse = async (pathUrl, method, data, ctx) => {
    return fetch(pathUrl, {
        method,
        body: data ? JSON.stringify(data) : null,
        cache: 'no-cache',
        // mode: 'cors',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            Authorization: getTokenFromCookie(ctx),
            'Content-Type': 'application/json'
        }
    })
}

const responseWorker = async (path, method = RequestMethod.GET, data, ctx, isThrowError) => {
    try {
        const response = await fetchResponse(path, method, data, ctx)
        const contentType = response.headers.get('content-type')
        const isJson = contentType && contentType.includes('application/json')

        if (response.ok && isJson) {
            const result = await response.json()
            if (result.isError) {
                if (!isThrowError)
                    console.error(
                        `ошибка при запросе path: ${path} idError: ${result?.idError || ''} ${result?.data || ''}`
                    )
                if (isThrowError) throw new Error(`ошибка при запросе ${path} ${result?.idError || ''}`)
            }
            setTokenAndUid(result, ctx)
            return result
        }

        if (!response.ok && response.status !== 401 && response.status !== 403) {
            const responseBody = !isJson ? await response.text() : await response.json()
            console.error(`ошибка при запросе url: ${path}; ${responseBody}`)
        } else if (!response.ok) {
            if (!isJson && response.status === 401 && response.status === 403)
                return {
                    isErrorResponse: true,
                    isForbidden: true
                }
            return await response.json()
        }

        return {
            isErrorResponse: true,
            response
        }
    } catch (e) {
        console.error(e)
        if (isThrowError) throw e
        return {
            isErrorResponse: true,
            e
        }
    }
}
// eslint-disable-next-line max-len
export const Get = (path, ctx = null, isThrowError = true) =>
    responseWorker(path, RequestMethod.GET, null, ctx, isThrowError)
// eslint-disable-next-line max-len
export const Post = (path, data = null, ctx = null, isThrowError = true) =>
    responseWorker(path, RequestMethod.POST, data, ctx, isThrowError)
